import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ErreurInternetComponent } from "./erreur-internet/erreur-internet.component";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslocoModule } from "@ngneat/transloco";


@NgModule({
  declarations: [ErreurInternetComponent],
  imports: [
    TranslocoModule,
    CommonModule,
    FuseSharedModule,
    // Import any other necessary modules here
  ],
  exports: [ErreurInternetComponent],

})
export class NoInternetModule { }
